


import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";

import bslogo from "./assets/companylogo.png";
import drone1 from "./assets/drone1.png";
import drone2 from "./assets/drone2.png";
import drone3 from "./assets/drone3.png";
import drone4 from "./assets/drone4.png";
import drone5 from "./assets/drone5.png";
import drone6 from "./assets/drone6.png";
import drone7 from "./assets/drone7.png";

import ThreeD from "./ThreeD";

function TungaDrones() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [navScrolled, setNavScrolled] = useState(false);
  const [activeTab, setActiveTab] = useState("available");

  useEffect(() => {
    const revealTargets = document.querySelectorAll(".reveal-up, .reveal-left, .reveal-right");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.12 }
    );
    revealTargets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const onScroll = () => setNavScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const availableDrones = [
    {
      name: "Drishya Lite",
      range: "3 km",
      endurance: "30 mins",
      category: "Light Surveillance",
      img: drone3,
    },
    {
      name: "Drishya Mini",
      range: "4 km",
      endurance: "40 mins",
      category: "Surveillance",
      img: drone2,
    },
    {
      name: "Drishya Pro M-I",
      range: "6 km",
      endurance: "60 mins",
      category: "Patrol",
      img: drone4,
    },
    {
      name: "Drishya Pro M-II",
      range: "10 km",
      endurance: "75 mins",
      category: "High Altitude",
      img: drone5,
    },
    {
      name: "Drishya Pro MK III",
      range: "10 km",
      endurance: "100 mins",
      category: "Advanced",
      img: drone6,
    },
    {
      name: "Log Drop 600G",
      range: "5 km",
      endurance: "60 mins",
      category: "Tactical",
      img: drone7,
    },
    {
      name: "Drishya iPro",
      range: "10 km",
      endurance: "60 mins",
      category: "AI Enabled",
      img: drone1,
    },
  ];

  const upcomingDrones = [
    {
      name: "Sanjay",
      tag: "VTOL Fixed Wing",
      specs: "150 min · 20 km · 5000m ceiling",
      endurance: "150 mins",
      range: "20 km",
      takeoff: "VTOL",
      weight: "11 kg",
    },
    {
      name: "Sanjay Plus",
      tag: "Fixed Wing",
      specs: "3.5 hrs · 75 km telemetry · EW-resistant",
      endurance: "210 mins",
      range: "75 km",
      takeoff: "Catapult",
      weight: "9.2 kg",
    },
    {
      name: "Drishya Max",
      tag: "Tail Sitter VTOL",
      specs: "120 min · 20 km · 4000m ceiling",
      endurance: "120 mins",
      range: "20 km",
      takeoff: "Tail Sitter",
      weight: "10 kg",
    },
    {
      name: "Vajra",
      tag: "Loitering Munition",
      specs: "50 min · 100 km/h · 3.6 kg warhead",
      endurance: "50 mins",
      range: "35 km",
      takeoff: "Catapult",
      weight: "11 kg",
    },
    {
      name: "Drishya Tether",
      tag: "Tethered UAS",
      specs: "~9 hrs endurance · Continuous power",
      endurance: "9 hrs",
      range: "Tethered",
      takeoff: "Stationary",
      weight: "Variable",
    },
  ];

  const certifications = [
    "🏅 ISO 9001:2015 Certified",
    "✈️ DGCA Certified UAS Manufacturer",
    "🚀 DPIIT Deep Tech Startup",
    "🇮🇳 Make in India (>50% IC)",
    "🛡️ DRDO Recognised",
    "🏭 Certified MSE",
  ];

  const customers = [
    { emoji: "🪖", name: "Indian Army" },
    { emoji: "⚓", name: "Indian Navy" },
    { emoji: "🛡️", name: "CRPF" },
    { emoji: "🔒", name: "CISF" },
    { emoji: "👮", name: "J&K Police" },
    { emoji: "🌲", name: "Gujarat Forest" },
    { emoji: "🌳", name: "MP Forest" },
    { emoji: "🏭", name: "SAIL" },
    { emoji: "🏛️", name: "Govt of Haryana" },
    { emoji: "🛰️", name: "KSRSAC" },
    { emoji: "🚢", name: "Integri Marine" },
  ];

  return (
    <div className="tunga-drones-page">
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        :root {
          --accent: #a3e635;
          --accent-2: #bef264;
          --accent-deep: #84cc16;
          --text-main: #eef2f7;
          --text-soft: #94a3b8;
          --heading-font: "Cinzel", serif;
          --body-font: "Manrope", sans-serif;
        }
        html, body { cursor: auto !important; }
        input, textarea { cursor: text !important; caret-color: #a3e635; }
        button, a, select, .tunga-back-button, .tunga-tab-btn { cursor: pointer !important; }
        html { scroll-behavior: smooth; }
        body { font-family: var(--body-font); color: var(--text-main); background: #0a0e1a; }

        .tunga-drones-page { position: relative; min-height: 100vh; overflow: hidden; }

        /* NAVBAR */
        .tunga-navbar {
          position: sticky;
          top: 0;
          z-index: 1000;
          background: rgba(19, 26, 44, 0.88);
          backdrop-filter: blur(16px);
          border-bottom: 1px solid rgba(163, 230, 53,0.12);
          box-shadow: 0 8px 28px rgba(15,23,42,0.05);
          transition: all 0.4s ease;
        }
        .tunga-navbar.scrolled { background: rgba(19, 26, 44, 0.98); box-shadow: 0 12px 40px rgba(15,23,42,0.14); }

        .tunga-nav-container {
          width: min(1220px, 92%);
          margin: 0 auto;
          padding: 14px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .tunga-nav-logo {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .tunga-nav-logo img {
          width: 54px;
          height: 54px;
          object-fit: contain;
          border-radius: 14px;
        }

        .tunga-site-title {
          font-family: var(--heading-font);
          font-size: 1.45rem;
          font-weight: 800;
          letter-spacing: 1px;
          color: #eef2f7;
        }

        .tunga-back-button {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          border: none;
          background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
          color: #fff;
          font-size: 18px;
          cursor: pointer;
          box-shadow: 0 10px 24px rgba(163, 230, 53,0.22);
          transition: all 0.3s ease;
        }

        .tunga-back-button:hover {
          transform: scale(1.12);
          box-shadow: 0 18px 38px rgba(163, 230, 53,0.35);
        }

        .tunga-nav-links {
          display: flex;
          align-items: center;
          gap: 22px;
        }

        .tunga-nav-links a {
          color: var(--text-soft);
          font-size: 0.96rem;
          font-weight: 700;
          text-decoration: none;
          position: relative;
          transition: color 0.28s ease;
        }

        .tunga-nav-links a:hover,
        .tunga-nav-links a.active { color: var(--accent-deep); }

        .tunga-nav-toggle {
          display: none;
          font-size: 1.8rem;
          color: #eef2f7;
          cursor: pointer;
        }

        /* COLLABORATION SECTION */
        .tunga-collaboration {
          background: #0a0e1a;
          padding: 60px 5%;
          margin-top: 60px;
          border-bottom: 1px solid rgba(163, 230, 53,0.12);
        }

        .tunga-collab-container {
          width: min(1220px, 92%);
          margin: 0 auto;
        }

        .tunga-collab-heading {
          font-family: var(--heading-font);
          font-size: clamp(1.8rem, 4vw, 2.5rem);
          color: var(--text-main);
          letter-spacing: 0.5px;
          font-weight: 700;
          margin-bottom: 24px;
          text-align: center;
        }

        .tunga-collab-heading::after {
          content: "";
          display: block;
          width: 64px;
          height: 4px;
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          border-radius: 3px;
          margin: 16px auto 0;
        }

        .tunga-collab-heading span {
          color: var(--accent-deep);
          font-weight: 800;
        }

        .tunga-collab-content {
          background: #131a2c;
          padding: 40px;
          border-radius: 20px;
          border: 1px solid rgba(163, 230, 53,0.12);
          box-shadow: 0 10px 30px rgba(15,23,42,0.08);
        }

        .tunga-collab-text {
          font-size: 1.05rem;
          line-height: 1.8;
          color: var(--text-soft);
          margin-bottom: 20px;
        }

        .tunga-collab-text strong {
          color: var(--accent-deep);
          font-weight: 700;
        }

        .tunga-collab-text:last-child {
          margin-bottom: 0;
        }

        .tunga-collab-highlight {
          background: rgba(163, 230, 53,0.08);
          border-left: 4px solid var(--accent-deep);
          padding: 20px;
          border-radius: 12px;
          margin-top: 20px;
        }

        .tunga-collab-highlight p {
          font-size: 1rem;
          color: var(--accent-2);
          font-weight: 600;
          margin: 8px 0;
        }

        /* CONTINUOUS SCROLLING CUSTOMERS */
        .tunga-customers-carousel {
          width: 100%;
          margin: 60px 0;
          padding: 50px 5%;
          background: linear-gradient(135deg, rgba(163, 230, 53,0.05), rgba(163, 230, 53, 0.02));
          border-top: 1px solid rgba(163, 230, 53,0.1);
          border-bottom: 1px solid rgba(163, 230, 53,0.1);
        }

        .tunga-customers-heading {
          font-family: var(--heading-font);
          font-size: 2rem;
          color: var(--text-main);
          margin-bottom: 40px;
          text-align: center;
          font-weight: 700;
          position: relative;
        }

        .tunga-customers-heading::after {
          content: "";
          display: block;
          width: 64px;
          height: 4px;
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          border-radius: 3px;
          margin: 16px auto 0;
        }

        .tunga-carousel-track {
          display: flex;
          gap: 20px;
          animation: scroll-left 40s linear infinite;
          width: fit-content;
        }

        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .tunga-carousel-container {
          overflow: hidden;
          width: 100%;
        }

        .tunga-customer-card {
          flex: 0 0 160px;
          background: linear-gradient(160deg, rgba(163, 230, 53, 0.22), rgba(19, 26, 44, 0.9));
          border: 1px solid rgba(163, 230, 53,0.3);
          border-radius: 16px;
          padding: 24px 16px;
          text-align: center;
          box-shadow: 0 8px 24px rgba(15,23,42,0.06);
          transition: all 0.3s ease;
          min-height: 140px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .tunga-customer-card:hover {
          transform: translateY(-6px) scale(1.04);
          box-shadow: 0 16px 40px rgba(163, 230, 53,0.25);
          background: linear-gradient(135deg, var(--accent-2), var(--accent));
        }

        .tunga-customer-emoji {
          font-size: 2.2rem;
          margin-bottom: 12px;
          display: block;
          line-height: 1;
        }

        .tunga-customer-name {
          font-size: 0.9rem;
          font-weight: 700;
          color: var(--text-main);
          line-height: 1.4;
          transition: color 0.3s ease;
        }

        .tunga-customer-card:hover .tunga-customer-name {
          color: #0a0e1a;
        }

        /* TABS */
        .tunga-tabs {
          width: min(1220px, 92%);
          margin: 60px auto;
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
          justify-content: center;
        }

        .tunga-tab-btn {
          padding: 12px 28px;
          border: 2px solid var(--accent);
          background: transparent;
          color: var(--accent);
          border-radius: 999px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 0.95rem;
        }

        .tunga-tab-btn.active {
          background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
          color: white;
          box-shadow: 0 10px 30px rgba(163, 230, 53,0.3);
        }

        .tunga-tab-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(163, 230, 53,0.2);
        }

        /* DRONE GRID */
        .tunga-drone-grid {
          width: min(1220px, 92%);
          margin: 60px auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 28px;
        }

        .tunga-drone-card {
          background: #131a2c;
          border: 1px solid rgba(163, 230, 53,0.14);
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(15,23,42,0.08);
          transition: all 0.35s ease;
          opacity: 0;
          transform: translateY(30px);
          animation: fadeInUp 0.6s ease forwards;
        }

        @keyframes fadeInUp {
          to { opacity: 1; transform: translateY(0); }
        }

        .tunga-drone-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 50px rgba(163, 230, 53,0.18);
        }

        .tunga-drone-image {
          width: 100%;
          aspect-ratio: 2 / 1;
          object-fit: cover;
          object-position: center;
          background: #0a0e1a;
          display: block;
        }

        .tunga-drone-content {
          padding: 24px;
        }

        .tunga-drone-content h3 {
          font-family: var(--heading-font);
          font-size: 1.3rem;
          color: var(--text-main);
          margin-bottom: 12px;
        }

        .tunga-drone-category {
          display: inline-block;
          background: rgba(163, 230, 53,0.1);
          color: var(--accent-deep);
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 0.75rem;
          font-weight: 700;
          margin-bottom: 12px;
        }

        .tunga-drone-specs {
          display: flex;
          flex-direction: column;
          gap: 8px;
          font-size: 0.9rem;
          color: var(--text-soft);
        }

        .tunga-spec {
          display: flex;
          justify-content: space-between;
          padding: 6px 0;
          border-bottom: 1px solid rgba(163, 230, 53,0.08);
        }

        .tunga-spec span {
          color: var(--accent);
          font-weight: 700;
        }

        .tunga-spec:last-child { border-bottom: none; }

        /* CERTIFICATIONS */
        .tunga-certs-section {
          width: min(1220px, 92%);
          margin: 80px auto;
          padding: 60px;
          background: #131a2c;
          border-radius: 32px;
          border: 1px solid rgba(163, 230, 53,0.1);
        }

        .tunga-certs-section h2 {
          font-family: var(--heading-font);
          font-size: 2.2rem;
          color: var(--text-main);
          margin-bottom: 40px;
          text-align: center;
        }

        .tunga-certs-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
        }

        .tunga-cert-item {
          background: linear-gradient(160deg, rgba(163, 230, 53, 0.22), rgba(19, 26, 44, 0.9));
          padding: 20px;
          border-radius: 16px;
          text-align: center;
          border: 1px solid rgba(163, 230, 53,0.3);
          box-shadow: 0 4px 12px rgba(15,23,42,0.05);
          transition: all 0.3s ease;
        }

        .tunga-cert-item:hover {
          transform: translateY(-4px);
          box-shadow: 0 10px 25px rgba(163, 230, 53,0.25);
          background: linear-gradient(135deg, var(--accent-2), var(--accent));
        }

        .tunga-cert-item:hover p {
          color: #0a0e1a;
        }

        .tunga-cert-item p {
          font-size: 0.95rem;
          color: var(--text-main);
          font-weight: 600;
        }

        /* FOOTER */
        .tunga-footer {
          background: linear-gradient(180deg, rgba(163, 230, 53, 0.08), #070a12 18%);
          color: white;
          padding: 60px 5%;
          margin-top: 80px;
          border-top: 3px solid var(--accent);
        }

        .tunga-footer-content {
          width: min(1220px, 92%);
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 50px;
          margin-bottom: 40px;
        }

        .tunga-footer-col h3 {
          font-family: var(--heading-font);
          font-size: 1.3rem;
          margin-bottom: 20px;
          color: var(--accent-2);
        }

        .tunga-footer-col p, .tunga-footer-col a {
          font-size: 0.95rem;
          line-height: 1.8;
          color: rgba(255,255,255,0.8);
          text-decoration: none;
        }

        .tunga-footer-col a:hover { color: var(--accent-2); }

        .tunga-social-links {
          display: flex;
          gap: 12px;
          margin-top: 20px;
        }

        .tunga-social-links a {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(163, 230, 53,0.2);
          display: grid;
          place-items: center;
          transition: all 0.3s ease;
          color: var(--accent-2);
        }

        .tunga-social-links a:hover {
          background: var(--accent);
          color: white;
          transform: translateY(-4px);
        }

        /* RESPONSIVE */
        @media (max-width: 768px) {
          .tunga-nav-toggle { display: block; }
          .tunga-nav-links {
            position: absolute;
            top: 82px; right: 4%;
            width: 240px;
            display: none;
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            padding: 20px;
            background: rgba(19, 26, 44, 0.98);
            border-radius: 18px;
            border: 1px solid rgba(163, 230, 53,0.14);
            box-shadow: 0 18px 40px rgba(15,23,42,0.12);
          }
          .tunga-nav-links.active { display: flex; }
          .tunga-collaboration { padding: 40px 5%; }
          .tunga-collab-heading { font-size: 1.5rem; }
          .tunga-collab-content { padding: 25px; }
          .tunga-collab-text { font-size: 0.95rem; }
          .tunga-customers-carousel { padding: 40px 5%; }
          .tunga-customers-heading { font-size: 1.5rem; margin-bottom: 30px; }
          .tunga-customer-card { flex: 0 0 140px; min-height: 130px; padding: 18px 12px; }
          .tunga-customer-emoji { font-size: 1.8rem; margin-bottom: 8px; }
          .tunga-customer-name { font-size: 0.8rem; }
          .tunga-carousel-track { gap: 16px; }
          .tunga-certs-section { padding: 40px; }
          .tunga-tabs { flex-direction: column; align-items: center; }
        }
      `}</style>

      <ThreeD />

      {/* NAVBAR */}
      <header className={`tunga-navbar${navScrolled ? " scrolled" : ""}`}>
        <div className="tunga-nav-container">
          <div className="tunga-nav-logo">
            
            <img src={bslogo} alt="Bliss Sierra" />
            <h1 className="tunga-site-title">Tunga UAVs</h1>
          </div>
          <div className="tunga-nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>

          <nav className={`tunga-nav-links${menuOpen ? " active" : ""}`}>
            <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
            <NavLink to="/Tunga-Drones" onClick={() => setMenuOpen(false)}>Tunga Drones</NavLink>
            <NavLink to="/Our-Projects" onClick={() => setMenuOpen(false)}>Our Projects</NavLink>
            <NavLink to="/Services" onClick={() => setMenuOpen(false)}>Services</NavLink>
            <NavLink to="/Careers" onClick={() => setMenuOpen(false)}>Careers</NavLink>
            <NavLink to="/OurTeam" onClick={() => setMenuOpen(false)}>Our Core Team</NavLink>
          </nav>
        </div>
      </header>

      {/* COLLABORATION SECTION */}
      <section className="tunga-collaboration reveal-up">
        <div className="tunga-collab-container">
          <h2 className="tunga-collab-heading"><span>Bliss Sierra</span> is Collaborating with <span>Tunga Aerospace</span></h2>
          <div className="tunga-collab-content">
            <p className="tunga-collab-text">
              In a strategic partnership, <strong>Bliss Sierra</strong> and <strong>Tunga Aerospace</strong> are joining forces to deliver cutting-edge <strong>unmanned aerial vehicle (UAV) solutions</strong> to the Indian defence and security sectors. This collaboration brings together expertise in advanced drone technology and defence systems.
            </p>
            <p className="tunga-collab-text">
              We specialize in <strong>designing, manufacturing, and selling high-performance drones</strong> that meet the demanding requirements of military, paramilitary, and civilian agencies across India. Our products combine indigenous innovation with international-grade quality standards.
            </p>
            <div className="tunga-collab-highlight">
              <p>🚁 Advanced Surveillance & Tactical UAVs</p>
              <p>🎯 Proven Track Record with Indian Armed Forces</p>
              <p>⚙️ Custom Solutions for Defence & Security Applications</p>
              <p>🏭 State-of-the-art Manufacturing Facility</p>
            </div>
          </div>
        </div>
      </section>

      {/* CONTINUOUS SCROLLING CUSTOMERS */}
      <section className="tunga-customers-carousel reveal-up">
        <h2 className="tunga-customers-heading">Tunga Customers</h2>
        <div className="tunga-carousel-container">
          <div className="tunga-carousel-track">
            {/* First set */}
            {customers.map((customer, i) => (
              <div className="tunga-customer-card" key={i}>
                <span className="tunga-customer-emoji">{customer.emoji}</span>
                <div className="tunga-customer-name">{customer.name}</div>
              </div>
            ))}
            {/* Duplicate set for infinite scroll */}
            {customers.map((customer, i) => (
              <div className="tunga-customer-card" key={`dup-${i}`}>
                <span className="tunga-customer-emoji">{customer.emoji}</span>
                <div className="tunga-customer-name">{customer.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TABS */}
      <div className="tunga-tabs">
        <button 
          className={`tunga-tab-btn ${activeTab === "available" ? "active" : ""}`}
          onClick={() => setActiveTab("available")}
        >
          Available Models (7)
        </button>
        <button 
          className={`tunga-tab-btn ${activeTab === "upcoming" ? "active" : ""}`}
          onClick={() => setActiveTab("upcoming")}
        >
          Under Development (5)
        </button>
      </div>

      {/* AVAILABLE DRONES */}
      {activeTab === "available" && (
        <div className="tunga-drone-grid">
          {availableDrones.map((drone, i) => (
            <div className="tunga-drone-card" key={i} style={{ animationDelay: `${i * 0.08}s` }}>
              <img src={drone.img} alt={drone.name} className="tunga-drone-image" />
              <div className="tunga-drone-content">
                <h3>{drone.name}</h3>
                <span className="tunga-drone-category">{drone.category}</span>
                <div className="tunga-drone-specs">
                  <div className="tunga-spec">
                    <strong>Range:</strong>
                    <span>{drone.range}</span>
                  </div>
                  <div className="tunga-spec">
                    <strong>Endurance:</strong>
                    <span>{drone.endurance}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* UPCOMING DRONES */}
      {activeTab === "upcoming" && (
        <div className="tunga-drone-grid">
          {upcomingDrones.map((drone, i) => (
            <div className="tunga-drone-card" key={i} style={{ animationDelay: `${i * 0.08}s` }}>
              <div style={{ 
                aspectRatio: '2 / 1',
                background: 'linear-gradient(135deg, rgba(163, 230, 53,0.1), rgba(163, 230, 53, 0.05))',
                display: 'grid',
                placeItems: 'center',
                fontSize: '3rem'
              }}>
                🚁
              </div>
              <div className="tunga-drone-content">
                <h3>{drone.name}</h3>
                <span className="tunga-drone-category">{drone.tag}</span>
                <div className="tunga-drone-specs">
                  <div className="tunga-spec">
                    <strong>Endurance:</strong>
                    <span>{drone.endurance}</span>
                  </div>
                  <div className="tunga-spec">
                    <strong>Range:</strong>
                    <span>{drone.range}</span>
                  </div>
                  <div className="tunga-spec">
                    <strong>Weight:</strong>
                    <span>{drone.weight}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* CERTIFICATIONS */}
      <section className="tunga-certs-section reveal-up">
        <h2>Certifications & Recognition</h2>
        <div className="tunga-certs-grid">
          {certifications.map((cert, i) => (
            <div className="tunga-cert-item" key={i}>
              <p>{cert}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="tunga-footer">
        <div className="tunga-footer-content">
          <div className="tunga-footer-col reveal-left">
            <h3>Tunga Aerospace</h3>
            <p>Pioneering advanced UAV solutions for defence and security applications across India.</p>
          </div>
          <div className="tunga-footer-col reveal-up">
            <h3>Quick Links</h3>
            <NavLink to="/">Home</NavLink><br/>
            <NavLink to="/Tunga-Drones">Tunga Drones</NavLink><br/>
            <NavLink to="/Our-Projects">Our Projects</NavLink><br/>
            <NavLink to="/Services">Services</NavLink><br/>
            <NavLink to="/Careers">Careers</NavLink><br/>
            <NavLink to="/OurTeam">Our Core Team</NavLink>
          </div>
          <div className="tunga-footer-col reveal-right">
            <h3>Contact</h3>
            <p>📍 Neelakanta Nilayam, Kakateeya Hiils, Road No 9, Madhapur, Hyderabad-500081</p>
            <p>📧 contact@blisssierra.com</p>
            <p>📞 +91-7702232247</p>
            <p>🇮🇳 Inspired by India</p>
            <div className="tunga-social-links">
              <a href="https://www.facebook.com/profile.php?id=61584931498008" target="_blank" rel="noreferrer"><FaFacebookF /></a>
              <a href="https://www.instagram.com/blisssierra1/" target="_blank" rel="noreferrer"><FaInstagram /></a>
              <a href="https://www.linkedin.com/feed/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
              <a href="https://wa.me/917702232247" target="_blank" rel="noreferrer"><FaWhatsapp /></a>
            </div>
          </div>
        </div>
        <div style={{ borderTop: "1px solid rgba(19, 26, 44, 0.1)", paddingTop: "30px", textAlign: "center", color: "rgba(19, 26, 44, 0.6)" }}>
          <p>&copy; 2026 Bliss Sierra x Tunga Aerospace. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default TungaDrones;